import React from "react";

export const ForgotPasswordForm = ({
  handleChange,
  handleSubmitUser,
  handleSubmitEmail,
  loading,
  credentials,
  lang,
}) => {
  return (
    <>
      <form
        onSubmit={handleSubmitUser}
        action="https://tes-par.tuclase.cl/login/index.php"
        method="post"
        style={{ marginTop: "15px" }}
      >
        <div className="col-md-12">
          <input
            onChange={handleChange}
            type="text"
            name="username"
            className="form-control box-ingreso2"
            placeholder={lang["Recovery"].first_send}
            value={credentials.username}
          />
        </div>
        <div className="col-md-12">
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block bot-text"
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-md mx-3"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <>{lang["Recovery"].third_send}</>
            )}
          </button>
        </div>
      </form>
      <form
        onSubmit={handleSubmitEmail}
        action="https://tes-par.tuclase.cl/login/index.php"
        method="post"
      >
        <div className="col-md-12">
          <input
            onChange={handleChange}
            type="email"
            name="email"
            className="form-control box-ingreso2"
            placeholder={lang["Recovery"].second_send}
            value={credentials.email}
          />
        </div>
        <div className="col-md-12">
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block bot-text"
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-md mx-3"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <>{lang["Recovery"].third_send}</>
            )}
          </button>
        </div>
      </form>
    </>
  );
};
